import { render } from "./AdminVisitsCleanup.vue?vue&type=template&id=5da4dbb6"
import script from "./AdminVisitsCleanup.vue?vue&type=script&lang=js"
export * from "./AdminVisitsCleanup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__